import React from "react";

const getInitials = (name) => {
  return name
    .split(" ") // Razdvaja ime i prezime
    .map((word) => word[0]) // Uzima prvo slovo svake reči
    .join("") // Spaja ih u string
    .toUpperCase(); // Osigurava da su velika slova
};

const ChatListItem = (props) => {
  const { data, isActive, onClick } = props || {};

  const fullName = `${data?.name} ${data?.lastName}`;
  return (
    <div
      className={`chat-left-content-item ${isActive ? "active" : ""}`}
      onClick={onClick}
    >
      <div className="chat-left-content-item-image">
        {data?.image ? (
          <img src={data?.image} className="img-fluid" alt={fullName} />
        ) : (
          <div className="chat-left-content-item-initial">
            {getInitials(fullName)}
          </div>
        )}
      </div>
      <div className="chat-left-content-item-content">
        <div className="chat-left-content-item-content-detail">
          <div className="chat-left-content-item-name">{fullName}</div>
          <div className="chat-left-content-item-compan-name">
            {data?.storeName}
          </div>
        </div>
        {data?.unreadCount > 0 && (
          <div className="chat-left-content-item-number">
            {data?.unreadCount}
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatListItem;
